import PageLoading from '@/components/specific/loaders/LoadingSpinner'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

interface ProtectedRouteInterface {
  children?: React.ReactNode
  accessBy: 'non-authenticated' | 'authenticated'
  isAuthenticated?: boolean
  loading?: boolean
}

/**
 * Renders a protected route based on the accessBy prop.
 * If accessBy is set to 'authenticated', it checks if the user is authenticated and renders the children or redirects to the login page.
 * If accessBy is set to 'non-authenticated', it checks if the user is not authenticated and renders the children or redirects to the home page.
 * If accessBy is not set to any of the above values, it redirects to the login page.
 */
const ProtectedRoute = ({
  children,
  accessBy,
  isAuthenticated,
  loading
}: ProtectedRouteInterface) => {

  const location: { state?: { from?: string }; pathname?: string } = useLocation()
  const from = location.state?.from || '/'

  switch (accessBy) {
    case 'authenticated':
      if (!isAuthenticated && loading) return <PageLoading />
      else if (isAuthenticated) return children ? children : <Outlet />
      else return <Navigate replace state={{ from: location.pathname }} to="/login" />

    case 'non-authenticated':
      if (!isAuthenticated) return children ? children : <Outlet />
      else return <Navigate replace to={from || '/'} />

    default:
      return <Navigate replace state={{ from: location.pathname }} to="/login" />
  }
}
export default ProtectedRoute
